import type { ImmerStateCreator } from 'hooks/useStore';

export interface TicketingAttachmentSlice {
  renameTicketAttachmentId: string | null;
  selectedTicketAttachmentName: string | null;
  selectedTicketAttachmentIdImgPreview: string | null;
  selectedTicketAttachmentIdPdfPreview: string | null;
  selectedTicketAttachmentIdDocPreview: string | null;
  selectedS3IdPdfPreview: string | null;
  selectedS3IdDocPreview: string | null;
  selectedFileType: string | null;
  isConverting: boolean;
  setRenameTicketAttachmentId: (id: string | null) => void;
  setSelectedTicketAttachmentName: (name: string | null) => void;
  setSelectedTicketAttachmentIdImgPreview: (id: string | null) => void;
  setSelectedTicketAttachmentIdPdfPreview: (id: string | null) => void;
  setSelectedTicketAttachmentIdDocPreview: (id: string | null) => void;
  setSelectedS3IdPdfPreview: (id: string | null) => void;
  setSelectedS3IdDocPreview: (id: string | null) => void;
  setSelectedFileType: (fileType: string | null) => void;
  setIsConverting: (status: boolean) => void;
}

export const useTicketingAttachmentSlice: ImmerStateCreator<
  TicketingAttachmentSlice
> = (set) => ({
  renameTicketAttachmentId: null,
  selectedTicketAttachmentName: null,
  selectedTicketAttachmentIdImgPreview: null,
  selectedTicketAttachmentIdPdfPreview: null,
  selectedTicketAttachmentIdDocPreview: null,
  selectedS3IdPdfPreview: null,
  selectedS3IdDocPreview: null,
  selectedFileType: null,
  isConverting: false,
  setRenameTicketAttachmentId: (id: string | null) =>
    set(
      (state) => {
        state.ticketingAttachmentSlice.renameTicketAttachmentId = id;
      },
      false,
      'setRenameTicketAttachmentId'
    ),
  setSelectedTicketAttachmentName: (name: string | null) =>
    set(
      (state) => {
        state.ticketingAttachmentSlice.selectedTicketAttachmentName = name;
      },
      false,
      'setSelectedTicketAttachmentName'
    ),
  setSelectedTicketAttachmentIdImgPreview: (id: string | null) =>
    set(
      (state) => {
        state.ticketingAttachmentSlice.selectedTicketAttachmentIdImgPreview =
          id;
      },
      false,
      'setSelectedTicketAttachmentIdImgPreview'
    ),
  setSelectedTicketAttachmentIdPdfPreview: (id: string | null) =>
    set(
      (state) => {
        state.ticketingAttachmentSlice.selectedTicketAttachmentIdPdfPreview =
          id;
      },
      false,
      'setSelectedTicketAttachmentIdPdfPreview'
    ),
  setSelectedTicketAttachmentIdDocPreview: (id: string | null) =>
    set(
      (state) => {
        state.ticketingAttachmentSlice.selectedTicketAttachmentIdDocPreview =
          id;
      },
      false,
      'setSelectedTicketAttachmentIdDocPreview'
    ),
  setSelectedS3IdPdfPreview: (id: string | null) =>
    set(
      (state) => {
        state.ticketingAttachmentSlice.selectedS3IdPdfPreview = id;
      },
      false,
      'setSelectedS3IdPdfPreview'
    ),
  setSelectedS3IdDocPreview: (id: string | null) =>
    set(
      (state) => {
        state.ticketingAttachmentSlice.selectedS3IdDocPreview = id;
      },
      false,
      'setSelectedS3IdDocPreview'
    ),
  setSelectedFileType: (id: string | null) =>
    set(
      (state) => {
        state.ticketingAttachmentSlice.selectedFileType = id;
      },
      false,
      'setSelectedFileType'
    ),
  setIsConverting: (status: boolean) =>
    set(
      (state) => {
        state.ticketingAttachmentSlice.isConverting = status;
      },
      false,
      'setIsConverting'
    ),
});
